import { getTranslation } from '@/lib/utils/i18n';
// Validation rules for the auth feature (ARCHITECTURE §2).
import { pattern, matches } from '@carboledger/ui';
import { REGEX } from '@/config/regex.constants';

export const loginValidation = {
  email: [pattern(REGEX.EMAIL, getTranslation('VALIDATION_EMAIL'))],
};

export const isOtpComplete = (value, length) => value.length === length;

export const newPasswordValidation = {
  password: [pattern(REGEX.STRONG_PASSWORD, getTranslation('VALIDATION_PASSWORD_STRENGTH'))],
  confirmPassword: [matches('password', getTranslation('VALIDATION_PASSWORDS_MISMATCH'))],
};

export const forgotPasswordValidation = {
  email: [pattern(REGEX.EMAIL, getTranslation('VALIDATION_EMAIL'))],
};
